module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu8.8733788c.png";